import * as Sentry from "@sentry/browser";

if(process.env.MIX_SENTRY_DSN_PUBLIC){
    Sentry.init({
        dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
        integrations: [
            Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],
		tracesSampleRate: 1.0,
		tracePropagationTargets: ["localhost",  /^\//],
		replaysSessionSampleRate: 1.0,
		replaysOnErrorSampleRate: 1.0,
    });
}
